export default "__VITE_ASSET__BYN9N9UB__"